/**
 * BONUS ENGINE -- ENDPOINTS
 * @description
 * [ENDPOINTS] - This are the list of endpoints for the bonus engine module
 */
// eslint-disable-next-line
export const BONUS_PROGRAMS = {
  FIND_ALL: 'bonus/findAll' as 'bonus/findAll',
  FIND_ID: 'bonus/findBonus' as 'bonus/findBonus',
  FIND_PROVIDERS: 'bonus/getProviders' as 'bonus/getProviders',
  FIND_PROVIDERS_CATEGORY: 'bonus/getProvidersCategories' as 'bonus/getProvidersCategories',
  FIND_GAMES_PROVIDER: 'bonus/getGames' as 'bonus/getGames',
  CREATE_BONUS: 'bonus/create' as 'bonus/create',
  UPDATE_BONUS: 'bonus/update' as 'bonus/update',
  DELETE_BONUS: 'bonus/delete' as 'bonus/delete',
}
